// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Error_overlay__1m_e3","message":"Error_message__11Uma"};